import { Code, CapsuleBar } from "../shared";

export const people = [
  {
    rel: "BOSS", name: "ELENA M.", score: 28, word: "PRESSURED", color: "#FF4D0A",
    codes: [["VS", "#FF4D0A"], ["AST", "#9DA1A8"]],
    call: "Hold the ask. THU opens. Stop bracing.",
  },
  {
    rel: "PARTNER", name: "SAM", score: 74, word: "OPEN", color: "#F2F0EB",
    codes: [["MRG", "#F2F0EB"]],
    call: "The money talk lands soft tonight.",
  },
  {
    rel: "CLIENT", name: "R. ADVISORY", score: 61, word: "STEADY", color: "#9DA1A8",
    codes: [["ENG", "#9DA1A8"]],
    call: "Push the timeline. They'll hold.",
  },
];

export const PersonCard = ({ p, delay = 0, compact = false }) => (
  <div className={`hairline bg-[#141518] ${compact ? "px-3 py-2.5" : "px-3.5 py-3"}`}>
    <div className="flex items-center justify-between">
      <div>
        <p className="font-mono-brand text-[8px] tracking-[0.25em] text-[#6E7178]">
          {p.rel} · <span className="text-[#9DA1A8]">{p.name}</span>
        </p>
        <div className="flex items-baseline gap-2 mt-1">
          <span className="font-mono-brand font-bold text-2xl leading-none text-[#F2F0EB]">{p.score}</span>
          <span className="h-heavy text-[10px] tracking-[0.15em]" style={{ color: p.color }}>{p.word}</span>
        </div>
      </div>
      <div className="flex gap-1.5">
        {p.codes.map(([c, col]) => <Code key={c} code={c} color={col} />)}
      </div>
    </div>
    <div className="mt-2">
      <CapsuleBar value={p.score} color={p.color} delay={delay} />
    </div>
    {!compact && <p className="text-[9px] text-[#9DA1A8] mt-2">{p.call}</p>}
  </div>
);

export const PeopleScreen = () => (
  <div className="px-4 pt-2 flex flex-col h-full">
    <div className="flex items-baseline justify-between px-1">
      <p className="h-heavy text-lg text-[#F2F0EB]">PEOPLE</p>
      <p className="font-mono-brand text-[8px] tracking-[0.25em] text-[#6E7178]">TUE · LIVE</p>
    </div>
    <div className="flex items-center justify-between bg-[#1A1C20] hairline px-3.5 py-2.5 mt-2.5">
      <p className="font-mono-brand text-[8px] tracking-[0.25em] text-[#9DA1A8]">YOU</p>
      <div className="flex items-baseline gap-2">
        <span className="font-mono-brand font-bold text-xl leading-none text-[#F2F0EB]">87</span>
        <span className="h-heavy text-[10px] tracking-[0.15em] text-[#FF4D0A]">CHARGED</span>
      </div>
    </div>
    <p className="font-mono-brand text-[8px] tracking-[0.3em] text-[#6E7178] mt-3 mb-2 px-1">CODE-TO-CODE</p>
    <div className="space-y-2.5">
      {people.map((p, i) => (
        <PersonCard key={p.rel} p={p} delay={0.2 + i * 0.12} />
      ))}
    </div>
  </div>
);
